var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01N(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 36.88,
    x2: 41.12,
    y1: 15.33,
    y2: 22.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fcd966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fccd34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.79,
    x2: 48.21,
    y1: 25.17,
    y2: 32.83,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 36.78,
    x2: 39.21,
    y1: 24.9,
    y2: 29.1,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.92,
    x2: 38.52,
    y1: 18.75,
    y2: 47.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eafcf"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    dur: "10s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "5 32 32; -15 32 32; 5 32 32"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M35.44 16.87l1.3 2.13a.55.55 0 01.06.5l-.8 2.36a.59.59 0 00.87.7l2.13-1.3a.55.55 0 01.5-.06l2.36.8a.59.59 0 00.7-.87L41.26 19a.55.55 0 01-.06-.5l.8-2.36a.59.59 0 00-.87-.7L39 16.74a.55.55 0 01-.5.06l-2.36-.8a.59.59 0 00-.7.87z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "3s",
    repeatCount: "indefinite",
    values: "1; 0; 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M42.27 30.82l2.49.07a.62.62 0 01.46.22l1.53 2a.6.6 0 001.07-.35l.07-2.49a.62.62 0 01.22-.46l2-1.53a.6.6 0 00-.35-1.07l-2.49-.07a.62.62 0 01-.46-.22l-1.53-2a.6.6 0 00-1.07.35l-.07 2.49a.62.62 0 01-.22.46l-2 1.53a.6.6 0 00.35 1.07z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1s",
    dur: "3s",
    repeatCount: "indefinite",
    values: "1; 0; 1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#fcd34d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M35.31 26.35l1.25 1.1a.4.4 0 01.14.31v1.66a.39.39 0 00.69.27l1.1-1.25a.4.4 0 01.31-.14h1.66a.39.39 0 00.27-.69l-1.25-1.1a.4.4 0 01-.14-.31v-1.66a.39.39 0 00-.69-.27l-1.1 1.25a.4.4 0 01-.31.14h-1.66a.39.39 0 00-.27.69z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-2s",
    dur: "3s",
    repeatCount: "indefinite",
    values: "1; 0; 1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#72b9d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M46.66 36.2a16.66 16.66 0 01-16.78-16.55 16.29 16.29 0 01.55-4.15A16.56 16.56 0 1048.5 36.1c-.61.06-1.22.1-1.84.1z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "10s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-5 32 32;15 32 32;-5 32 32"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "10s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "-5 32 32; 15 32 32; -5 32 32"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01N);
export default __webpack_public_path__ + "static/media/01n.509aeabb26c7a8f18dc5b88986e22b67.svg";
export { ForwardRef as ReactComponent };